import { render } from "./service-list.vue?vue&type=template&id=7d1624c8&scoped=true"
import script from "./service-list.vue?vue&type=script&lang=js"
export * from "./service-list.vue?vue&type=script&lang=js"

import "./service-list.vue?vue&type=style&index=0&id=7d1624c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d1624c8"]])

export default __exports__